import { JOKI } from "../../../JOKI";
import keyExists from "../../../utils/keyExists";
import { warning } from "../../Notifications/notice";
import { endpointRequest } from "../../EndpointService/EndpointFunctions";

const METADATACONVERSION = {
    lon: "coordinates_lon",
    lat: "coordinates_lat",
};

function parseNewMeta(newMeta, oldMeta) {
    try {
        // const metaObj = Object.assign({}, oldMeta, JSON.parse(newMeta.metaJson));
        const newMetaData = JSON.parse(newMeta.metaJson);
        const newMetaDataKeys = Object.keys(newMetaData);

        const metaObj = newMetaDataKeys.reduce((acc, cur) => {
            acc[cur] = newMetaData[cur];
            return acc;
        }, {});

        for (let key in METADATACONVERSION) {
            const value = newMeta[key];
            const realKey = METADATACONVERSION[key];
            metaObj[realKey] = value;
        }

        const address = {
            street: newMeta.street,
            street2: newMeta.street2,
            city: newMeta.city,
            zipcode: newMeta.zipcode,
            state: newMeta.state,
            country: newMeta.country,
        };

        metaObj.address = address;

        return metaObj;
    } catch (err) {
        console.error("ERROR!", err);
        return false;
    }
}

export function MetaDataUpdate(device, newMetaData) {
    return new Promise((resolveChanges, rejectChanges) => {
        newMetaData.description = newMetaData.description === "" ? null : newMetaData.description;
        newMetaData.name = newMetaData.name === "" ? null : newMetaData.name;

        const updateName = newMetaData.name !== device.name;
        const updateDescription = newMetaData.description !== device.description;

        const promises = [];

        if (updateName !== false || updateDescription !== false) {
            promises.push(
                UpdateNameAndDescription(
                    device,
                    updateName === true ? newMetaData.name : device.name,
                    updateDescription === true ? newMetaData.description : device.description
                )
            );
        }

        const metaData = parseNewMeta(newMetaData, keyExists("metadata.raw", device) ? device.metadata.raw : {});
        if (metaData === false) {
            warning("Provided meta data is invalid.");
            rejectChanges();
        }


        promises.push(endpointRequest(JOKI, "device_metadata_update", {
            body: metaData,
            urlParse: {
                "$deviceCode$": device.code
            }
        }));

        Promise.all(promises)
            .then(results => {
                const fetches = results.map(res => res.FetchService);
                Promise.all(fetches)
                    .then(fetchResults => {
                        resolveChanges(device);
                    })
                    .catch(err => {
                        rejectChanges(err);
                    });
            })
            .catch(err => {
                rejectChanges(err);
            });
    });
}

export function UpdateNameAndDescription(device, name = "", description = "") {
    if (device.code === undefined) {
        console.warn("No Code defined for device. Cannot change the name nor description.");
        return;
    }

    const dataBody = {
        name: name === null ? "" : name,
        description: description === null ? "" : description,
    };


    return endpointRequest(JOKI, "device_update", {
        body: dataBody,
        urlParse: {
            "$deviceCode$": device.code
        }
    });
    // return JOKI.ask({
    //     to: "FetchService",
    //     key: "request",
    //     body: {
    //         method: "PUT",
    //         url: `Devices/${device.code}`,
    //         body: dataBody,
    //     },
    // });
}
